import { useEffect, useRef } from "react";
import { NavLink, useLocation } from "react-router-dom";

export default function SectionTabs({ items }) {
  const wrapRef = useRef(null);
  const loc = useLocation();

  useEffect(() => {
    const el = wrapRef.current?.querySelector('[aria-current="page"]');
    if (el) el.scrollIntoView({ inline: "center", block: "nearest" });
  }, [loc.pathname]);

  return (
    <div className="sticky top-[58px] md:top-0 z-40 bg-paper/90 backdrop-blur-xl border-b border-hairline" data-testid="section-tabs">
      <div ref={wrapRef} className="h-12 flex items-center gap-1.5 px-4 md:px-8 overflow-x-auto noscrollbar">
        {items.map((it) => (
          <NavLink
            key={it.key}
            to={it.path}
            data-testid={`section-tab-${it.key}`}
            className={({ isActive }) =>
              `whitespace-nowrap rounded-full px-3.5 py-1.5 text-xs font-semibold transition-colors ${
                isActive ? "bg-ember/10 text-ember-press" : "text-sand-600 hover:bg-sand-100 hover:text-ink"
              }`
            }
          >
            {it.label}
          </NavLink>
        ))}
      </div>
    </div>
  );
}
